import React from 'react';
import { Loader } from '@qred/components-library';

const Loading = () => {
  return <Loader data-testid="update-application-loader" />;
};

export default Loading;
